<template>
  <div class="home-box">
    <h2 class="gray_dk--text">Reports</h2>
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">

      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <h3 class="orange--text">
          Activity Reports
        </h3>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ActivityClubWiseReport></ActivityClubWiseReport>
      </v-col>
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ActivityZoneWiseReport></ActivityZoneWiseReport>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <h3 class="orange--text">
          Service Project Reports
        </h3>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ThemeWiseReport></ThemeWiseReport>
      </v-col>
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ProjectClubWiseReport></ProjectClubWiseReport>
      </v-col>
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ProjectZoneWiseReport></ProjectZoneWiseReport>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <h3 class="orange--text">
          Contribution Reports
        </h3>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ContributionClubWiseReport></ContributionClubWiseReport>
      </v-col>
      <v-col cols="12" xs="12" md="12" class="h-100">
        <ContributionZoneWiseReport></ContributionZoneWiseReport>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import ActivityClubWiseReport from "../../components/activities/reports/ActivityClubWiseReport";
import ActivityZoneWiseReport from "../../components/activities/reports/ActivityZoneWiseReport";
import ContributionClubWiseReport from "../../components/activities/reports/ContributionClubWiseReport";
import ContributionZoneWiseReport from "../../components/activities/reports/ContributionZoneWiseReport";
import ThemeWiseReport from "../../components/service-projects/reports/ThemeWiseReport";
import ProjectClubWiseReport from "../../components/service-projects/reports/ProjectClubWiseReport";
import ProjectZoneWiseReport from "../../components/service-projects/reports/ProjectZoneWiseReport";

export default {
  name: "Projects",
  components: {
    ActivityClubWiseReport,
    ContributionClubWiseReport,
    ContributionZoneWiseReport,
    ThemeWiseReport,
    ProjectClubWiseReport,
    ActivityZoneWiseReport,
    ProjectZoneWiseReport
  },
  data: function () {
    return {
      loading: false,
      role: localStorage.getItem("role"),
      statsNotFound: require("@/assets/img/stats_empty.png"),

    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },
  mounted() { },

  watch: {},

  methods: {
  },
};
</script>
